// extracted by mini-css-extract-plugin
export var copyableField = "_pq-4";
export var customerBadge = "_pq-0";
export var customerInfoTitle = "_pq-2";
export var details = "_pq-1";
export var dropdownContainer = "_pq-5";
export var dropdownImage = "_pq-6";
export var editAssigneeForm = "_pq-a";
export var editButton = "_pq-3";
export var email = "_pq-7";
export var hidden = "_pq-d";
export var input = "_pq-8";
export var saveButton = "_pq-b";
export var shopifyIcon = "_pq-c";
export var suggestionBadge = "_pq-e";
export var suggestionText = "_pq-f";
export var username = "_pq-9";